import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { ITimestampJSON } from '../domain/TransportPlanTimestamp'
import { getTimestampDelayType } from '../service/TransportPlan2'
import { getColorClass } from './TpDelay'

export const testIds = {
  reason: 'tp_reason',
}

interface ReasonProps {
  colorClass: string
  reason: string
}
export const Reason: FC<ReasonProps> = ({ colorClass, reason }) => {
  if (!reason) {
    return null
  }
  const { translateIfExists } = useI18n()
  return (
    <div data-testid={testIds.reason} className={colorClass}>
      {translateIfExists(reason)}
    </div>
  )
}

interface TimestampReasonFurthestLatestProps {
  furthestTimestamp: ITimestampJSON
  latestTimestamp: ITimestampJSON
}

export const getTimeStamp = (furthestTimestamp: ITimestampJSON, latestTimestamp: ITimestampJSON): ITimestampJSON => {
  if (furthestTimestamp && furthestTimestamp.delay && furthestTimestamp.reason) {
    return furthestTimestamp
  }
  if (latestTimestamp && latestTimestamp.delay && latestTimestamp.reason) {
    return latestTimestamp
  }
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'ITimestampJ... Remove this comment to see the full error message
  return null
}

export const TimestampReasonFurthestLatest: FC<TimestampReasonFurthestLatestProps> = ({
  furthestTimestamp,
  latestTimestamp,
}) => {
  const timestamp = getTimeStamp(furthestTimestamp, latestTimestamp)

  if (!timestamp || (timestamp && !!timestamp.causedBy)) {
    return null
  }

  // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const { delayType, isZero } = getTimestampDelayType(timestamp.delay)
  const colorClass: string = getColorClass(delayType, isZero)
  return <Reason colorClass={colorClass} reason={timestamp.reason} />
}
